import {useEffect} from "react";
import {useForm, Controller} from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import Button from "~/components/Button";
import Loading from "~/components/Loading";
import {
	InputField,
} from "~/components/Forms";

function ReceiptGroupFormAddEdit({item, onHandleSubmit}) {

	const isEdit = Boolean(item?.id);

	const initialValues = {
		name: '',
		note: '',
	}

	const validationSchema = Yup.object().shape({
		name: Yup.string().required('Bạn chưa điền tên loại phiếu thu'),
	})

	const { control, handleSubmit, formState: { isSubmitting, errors }, reset } = useForm({
		defaultValues: initialValues,
		resolver: yupResolver(validationSchema)
	});

	useEffect(() => {
		if(item?.id) {
			initialValues.name = item.name;
			initialValues.note = item.note || '';
		}
		reset(initialValues);
	}, [item]);

	const onSubmit = async (data) => {
		await onHandleSubmit(data, isEdit);
	}

	return (
		<form className="form" onSubmit={handleSubmit(onSubmit)}>
			{isSubmitting && <Loading/>}
			<Controller control={control} name="name" render={({field}) => (
				<InputField label="Tên loại phiếu thu" errors={errors} {...field}/>
			)}/>
			<Controller control={control} name="note" render={({field}) => (
				<InputField label="Ghi chú" errors={errors} {...field}/>
			)}/>
			<hr />
			<div className="form-group d-flex justify-content-end modal-bottom">
				<Button primary type="submit">{isEdit ? 'Cập nhật' : 'Thêm'} loại phiếu thu</Button>
			</div>
		</form>
	)
}

export default ReceiptGroupFormAddEdit;

